import { storeToRefs } from 'pinia';
import { Comment } from 'vue';

// TODO - fix ssr render
export default defineNuxtComponent({
    name: 'ProductComponent',
    props: {
        hideOn: {
            type: [Array, String],
        },
        noFallback: Boolean,
        debug: Boolean,
    },
    setup(props, { slots }) {
        const { $pinia } = useNuxtApp();

        const { currentProductCode } = storeToRefs(useProductStore($pinia));

        // convert hideOn to array if it's not
        const hiddenOn = computed(() =>
            props.hideOn
                ? Array.isArray(props.hideOn)
                    ? props.hideOn
                    : [props.hideOn]
                : [],
        );

        if (
            !currentProductCode.value ||
            hiddenOn.value.includes(currentProductCode.value)
        ) {
            return () => h(Comment);
        }

        // Get all multi fallback components
        const defaultContent = computed(() => {
            if (props.noFallback || slots[currentProductCode.value]) {
                return null;
            }

            const content = (slots.fallback ?? slots.default)();

            // if content length is 1 return it as default
            if (content.length === 1) {
                return {
                    default: content[0],
                };
            }

            // if content length is more than 1, iterate over all children and return split them
            return content.reduce((acc, child) => {
                if (child.type.__name === 'MultipleProductDefault') {
                    child.props.products.forEach((product) => {
                        acc[product] = child;
                    });

                    return acc;
                }

                // if acc.default is not set, set it to current child
                if (!acc.default) {
                    acc.default = child;

                    return acc;
                }

                // if acc.default is not an array, convert it to array
                if (!Array.isArray(acc.default)) {
                    acc.default = [acc.default];
                }

                acc.default.push(child);
                return acc;
            }, {});
        });

        const hasSlots = !!(
            slots[currentProductCode.value] ??
            slots.fallback ??
            slots.default
        );

        // check if slot for current product exists or we have a fallback
        if (!hasSlots && props.noFallback) {
            return () => h(Comment);
        }

        if (!hasSlots) {
            console.error(
                `No template found for product ${currentProductCode.value}, fallback or default.`,
            );

            return () =>
                h(
                    'div',
                    `No template found for product ${currentProductCode.value}, fallback or default.`,
                );
        }

        // return slot corresponding to current product
        return () => {
            if (slots[currentProductCode.value]) {
                return h(slots[currentProductCode.value]);
            }

            if (!defaultContent.value) {
                return h(Comment);
            }

            if (defaultContent.value[currentProductCode.value]) {
                return h(defaultContent.value[currentProductCode.value]);
            }

            if (Array.isArray(defaultContent.value.default)) {
                return h('div', defaultContent.value.default);
            }

            return h(defaultContent.value.default);
        };
        // h(
        //     slots[currentProductCode.value] ??
        //         slots.fallback ??
        //         slots.default
        // );
    },
});
